/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createIsNumeric } from '../../factoriesAny.js';
export var isNumericDependencies = {
  typedDependencies,
  createIsNumeric
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesIsNumeric.generated.js
// module id = 52UI
// module chunks = 3